/**
 * YEDİNCİ DALGA SALDIRI KORPUSU (QA, 16.09.2026) - AYRI DOSYA.
 *
 * `email-mask-probes.ts` bu dalgayla 617 satıra çıkıyordu ve kaynak tavanı 500
 * (`file-size-ceiling.guard.spec`). Dalga kendi dosyasında durur ve ana korpusa
 * YAYILARAK katılır; üç yüzey (birim · panel DOM'u · api e2e) tek listeden
 * beslenmeye devam eder.
 *
 * DALGANIN ÖZELLİĞİ: kaçamak SAYISI değil, YÖN tersine dönmüştü. Yapısal
 * indirgeme atıl maddeyi İÇİNDEKİYLE BİRLİKTE siliyordu; adres atıl maddenin
 * İÇİNDEYSE kanonik biçimde eşleşme kalmıyor, `maskEmailsWith` "adres yok"
 * deyip ÖZGÜN dizeyi HAM döndürüyordu. Yani metin ne kadar çok etiket/yorum/
 * CDATA taşırsa maskelemeden kaçma olasılığı o kadar ARTIYORDU.
 */
/**
 * P2-1 ADLI VARLIKLARI ÜRETİLİR, TEK TEK YAZILMAZ.
 *
 * On dördü de AYNI kusurun aynı yazımıdır (tablo on bir üyeydi, bunlar yoktu)
 * ve elle yazmak listeyi kapının MEKANİZMASI gibi gösterirdi. Mekanizma liste
 * değil ROL kuralıdır (`email-mask-decoders.ts` 2e); bu satırlar REGRESYON
 * kaydıdır ve üretilerek durur. Rolün kendisini `email-mask.spec.ts` 17. AYAK
 * uydurma bir varlık adıyla ölçer.
 */
const ADLI_VARLIKLAR = [
    ['shy', 'yumuşak tire'],
    ['zwnj', 'sıfır genişlikli birleştirmeyen'],
    ['zwj', 'sıfır genişlikli birleştirici'],
    ['ZeroWidthSpace', 'sıfır genişlikli boşluk'],
    ['lrm', 'soldan sağa işareti'],
    ['rlm', 'sağdan sola işareti'],
    ['NoBreak', 'kelime birleştirici'],
    ['ensp', 'en boşluğu'],
    ['emsp', 'em boşluğu'],
    ['thinsp', 'ince boşluk'],
    ['hairsp', 'kıl boşluğu'],
    ['zwsp', 'sıfır genişlikli boşluk (kısa ad)'],
    ['Tab', 'sekme'],
    ['NewLine', 'satır sonu'],
];
const ADLI_VARLIK_PROBLARI = ADLI_VARLIKLAR.map(([varlik, aciklama], sira) => ({
    ad: `HTML adlı varlık \`&${varlik};\` (${aciklama})`,
    metin: `550 5.1.1 qa7ad${sira + 1}&${varlik};@ornek.com: user unknown`,
    sizmamali: ['ornek.com', `qa7ad${sira + 1}`],
}));
export const YEDINCI_DALGA_PROBLARI = [
    /*
     * P1 YÜKLERİ - ONU DA ÜRETİM YAZMA YOLUNDA ÖLÇÜLDÜ.
     *
     * Önceki dalga atıl maddeyi SÖKEREK kapatmıştı ve tasarımın varsayımı *"atıl
     * madde adres İÇERMEZ"*di. Sağlayıcının HTML/XML gövdesinde bu varsayım
     * YANLIŞ: söküm adresi de siliyor, kanonik biçimde eşleşme kalmıyor,
     * `maskEmailsWith` "adres yok" deyip ÖZGÜN dizeyi HAM döndürüyordu. Ölçüm
     * (üretim yazma yolu · gerçek Postgres · ham HTTP gövdesi · panel DOM'u):
     * kolonda 10/10, gövdede 6 tam adres + 10 alan adı, panelde 10/10 GÖZLE
     * okunuyordu - ve `containsEmail` 10/10'unda `false` diyordu, yani ÖLÇÜ
     * ARACININ KENDİSİ KÖRDÜ.
     *
     * Aşağıdaki ilk on satır o yüklerdir ve hepsi GERÇEK sağlayıcı/WAF/proxy
     * gövdesi biçimidir. Kapanış: çok görünümlü maskeleme (`email-mask.ts` ·
     * `MASKE_GORUNUMLERI`) - hiçbir görünümün "bulamadım"ı tek başına bağlayıcı
     * değil ve görünümlerden biri KAYIPSIZ.
     */
    {
        ad: 'HTML bağlantısı - adres `href` ÖZNİTELİĞİNİN içinde',
        metin: '<a href="mailto:qa7p1@ornek.com">contact</a> - 550 delivery failed',
        sizmamali: ['qa7p1@ornek.com', 'ornek.com', 'qa7p1'],
    },
    {
        ad: 'HTML YORUMUNUN içinde adres (söküm adresi de siliyordu)',
        metin: '550 failed <!-- recipient: qa7p2@ornek.com --> see log',
        sizmamali: ['qa7p2@ornek.com', 'ornek.com', 'qa7p2'],
    },
    {
        ad: 'CDATA bölümünün İÇİNDE adres',
        metin: '550 <![CDATA[qa7p3@ornek.com]]> rejected',
        sizmamali: ['qa7p3@ornek.com', 'ornek.com', 'qa7p3'],
    },
    {
        ad: 'XML işlem yönergesinin İÇİNDE adres',
        metin: '550 <?smtp to="qa7p4@ornek.com"?> rejected',
        sizmamali: ['qa7p4@ornek.com', 'ornek.com', 'qa7p4'],
    },
    {
        ad: 'DOCTYPE bildiriminin İÇİNDE adres',
        metin: '550 <!DOCTYPE to SYSTEM "qa7p5@ornek.com"> rejected',
        sizmamali: ['qa7p5@ornek.com', 'ornek.com', 'qa7p5'],
    },
    {
        ad: 'HTML ÖZNİTELİK değerinde adres (`value=`)',
        metin: '<input type="email" value="qa7p6@ornek.com" /> 550 blocked',
        sizmamali: ['qa7p6@ornek.com', 'ornek.com', 'qa7p6'],
    },
    {
        ad: 'SES XML hata gövdesi - iç içe etiket + CDATA (gerçek biçim)',
        metin: '<Error><Message><![CDATA[Email address is not verified: qa7p7@ornek.com]]></Message></Error>',
        sizmamali: ['qa7p7@ornek.com', 'ornek.com', 'qa7p7'],
    },
    {
        ad: 'Postfix uzak sunucu yanıtı - adres `@`ye BİTİŞİK parantezin içinde',
        metin: 'status=deferred a@ (host said: 550 qa7p8@ornek.com rejected)',
        sizmamali: ['qa7p8@ornek.com', 'ornek.com', 'qa7p8'],
    },
    {
        /*
         * A YÖNÜNÜN (atıl maddeyi ayırıcıya indirgeme) TEK BAŞINA TAŞIDIĞI YÜK.
         * Ham görünüm bu metinde `@` göremez (`%40` kodlu), kanonik görünüm etiketi
         * bütünüyle siler; yalnız `atil-korunmus` görünümü öznitelik metnini
         * koruduğu için çözücü `%40`ı `@` yapabilir. Kapı bunu 17. AYAK'ta ölçer.
         */
        ad: 'HTML bağlantısı + YÜZDE KODLU adres (`mailto:...%40...`)',
        metin: '<a href="mailto:qa7p9%40ornek.com">contact</a> failed 400',
        sizmamali: ['ornek.com', 'qa7p9'],
    },
    {
        ad: 'HTML bağlantısı + AYRAÇLI gizleme (`(at)` / `(dot)`) öznitelikte',
        metin: '<a href="mailto:qa7p10(at)ornek(dot)com">contact</a> failed',
        sizmamali: ['ornek', 'qa7p10'],
    },
    ...ADLI_VARLIK_PROBLARI,
    /*
     * YEDİNCİ DALGA / P2-2 - SARMALANMIŞ VE ÇOKLU `@`.
     *
     * `AYRACLI_SIKI_AT` ayraç içinde `\p{L}{1,10}` arıyordu ve `@` HARF DEĞİLDİR:
     * `(a)` kapatılmış, `(@)` açık kalmıştı. `|@|` ve `*@*` ise ayraç ÇİFTİ değil,
     * aynı karakterin iki yanda tekrarıdır. `@@` ise ne YEREL'e ne ALAN'a girdiği
     * için deseni bütünüyle atlatıyordu.
     */
    {
        ad: 'ayraç içinde `@` - `(@)`',
        metin: '550 qa7at1(@)ornek.com rejected',
        sizmamali: ['ornek.com', 'qa7at1'],
    },
    {
        ad: 'ÇİFT `@` - `@@`',
        metin: '550 qa7at2@@ornek.com rejected',
        sizmamali: ['ornek.com', 'qa7at2'],
    },
    {
        ad: 'köşeli ayraç içinde `@` - `[@]`',
        metin: '550 qa7at3[@]ornek.com rejected',
        sizmamali: ['ornek.com', 'qa7at3'],
    },
    {
        ad: 'süslü ayraç içinde `@` - `{@}`',
        metin: '550 qa7at4{@}ornek.com rejected',
        sizmamali: ['ornek.com', 'qa7at4'],
    },
    {
        ad: 'AYNI karakterle sarmalanmış `@` - `|@|`',
        metin: '550 qa7at5|@|ornek.com rejected',
        sizmamali: ['ornek.com', 'qa7at5'],
    },
    {
        ad: 'AYNI karakterle sarmalanmış `@` - `*@*`',
        metin: '550 qa7at6*@*ornek.com rejected',
        sizmamali: ['ornek.com', 'qa7at6'],
    },
    /*
     * YEDİNCİ DALGA / SINIF TARAMASI EKİ (geliştirici, 16.09.2026). QA'nın
     * listesinde YOKTU, aynı sınıfın taranmasında çıktı: çözücü yerel adın İÇİNE
     * bir `@` getirdiğinde kanonik biçim `L@D1@D2` oluyor, desen açgözlü biçimde
     * `L@D1`i alıyor ve ALAN ADI ekranda `[eposta]@ornek.com` olarak HAM
     * kalıyordu. Üç ayrı çözücü aynı şekli üretiyor. Kapanış: `(?:@ALAN)+`.
     */
    {
        ad: 'çözücü yerel ada `@` getirdi - yüzde kodu (`%40`)',
        metin: 'POST /v3/messages?to=qa7z1%40veli@ornek.com failed 400',
        sizmamali: ['ornek.com', 'veli'],
    },
    {
        ad: 'çözücü yerel ada `@` getirdi - base64 gövde',
        metin: '550 YWxpQHguY28@ornek.com rejected',
        sizmamali: ['ornek.com', 'x.co'],
    },
    {
        ad: 'çözücü yerel ada `@` getirdi - onaltılık gövde',
        metin: '550 616c6940782e636f@ornek.com rejected',
        sizmamali: ['ornek.com', 'x.co'],
    },
];
//# sourceMappingURL=email-mask-probes-7.js.map